<dashboard-dialog-frame class="engagement-editor-dialog" [header]="headerTitle()" icon="fa-question-circle" [dialogRef]="dialogRef">

	@if(showEngagementForm() === true) {
	<div class="d-flex flex-column gap-2 p-2">
		<person-finder-widget (selectedRowId)="setSelectedPersonId($event)"
			[selectedPersonName]="selectedPersonName" [hasPersonFieldError]="hasPersonFieldError"
			[disabled]="searchPersonDisabled()"></person-finder-widget>

		<common-date-time-field [field]="form.engagementDate()"></common-date-time-field>

		<common-select-field [field]="form.externalRoleId()"></common-select-field>

		<common-select-field [field]="form.staffRoleId()"></common-select-field>

		<common-select-field [field]="form.purpose()"></common-select-field>

		<common-select-field [field]="form.activity()"></common-select-field>

		<div class="py-2 mb-2">
			<div class="white-box d-flex flex-column gap-2">
				<div class="d-flex justify-content-between mb-2">
					<p class="mb-0">Initial Interaction</p>
				</div>
				<staff-selector-widget [disabled]="false" [data]="staffData()" [userId]="app.data().user.userId"
					[value]="{staffId: values().contactInteraction.staffId}"
					(valueChange)="handleStaffValueChange($event)"></staff-selector-widget>
				<common-select-field [field]="form.contactMethod()"></common-select-field>
				<common-date-time-field [field]="form.contactedDate()"></common-date-time-field>
			</div>
		</div>
		<common-text-field [field]="form.details()"></common-text-field>

		<div class="mb-2 d-flex flex-row gap-2">
			<input class="form-check-input fs-6" type="checkbox" name="field-checkbox-donorPotential"
				id="donorPotentialCheckbox" [ngModel]="form.isDonorPotential()"
				(ngModelChange)="onChangeDonorPotential($event)" [disabled]="false" />
			<label class="form-check-label" for="donorPotentialCheckbox">
				Donor Potential
			</label>
		</div>

		@if(form.isDonorPotential() === true){
		<common-text-field class="mb-2" [field]="form.donorPotentialDetails()"></common-text-field>
		}

		<common-button-row [center]="true">
			<button class="btn btn-standard" #addBtn>{{ buttonText()}}</button>
			<button class="btn btn-standard" (click)="saveAndMarkClosed()" [disabled]="saveAndCloseButtonDisabled()">Save and Mark Closed</button>
			<button class="btn btn-standard" (click)="closeDialog()">Close</button>
		</common-button-row>
	</div>
	}

</dashboard-dialog-frame>